module.exports = {
  INFRACTION_REPORTED: 'INFRACTION_REPORTED'
};
